<template>
  <EmdFormGroup
    :label="$t('monthly-icome')"
    :state="getState($v.recipient.monthly_income)"
    :feedbacks="feedbacks($v.recipient.monthly_income)"
    required
  >
    <EmdInput
      @input="() => $v.recipient.monthly_income.$touch()"
      v-model="recipient.monthly_income"
      mask="R$ ############"
      name="founding_date"
      :readonly="disabled"
      :disabled="disabled"
    />
  </EmdFormGroup>
</template>

<script>
import { EmdFormGroup, EmdInput } from 'emerald-vue/src/components'
import { getState, feedbacks } from '@/utils/form.utils'
import { managingPartners } from '../validations'
export default {
  name: 'MonthlyIncomeInput',
  components: {
    EmdFormGroup,
    EmdInput
  },
  data: () => ({
    getState,
    feedbacks,
    monthly_income: ''
  }),
  props: {
    recipient: {
      type: Object
    },
    disabled: {
      type: Boolean
    }
  },
  validations () {
    return { recipient: managingPartners }
  }
}
</script>

<i18n>
  {
    "pt-BR": {
      "monthly-icome": "Faturamento mensal"
    },
    "en-US": {
      "monthly-icome":  "Monthly income"
    }
  }
</i18n>
